/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const blocktime_explanation_dialog_text = () => `Block time is the average amount of time it takes for a new block to be added to a blockchain.<br /><br />This metric is calculated as an average based on different time intervals (hour/day/week/month)`
